import { Reveal } from "@/components/Reveal";
import { IMAGES } from "@/lib/site";

const FLEET = [
  {
    idx: "01",
    caption: "Isuzu 1-Ton Bakkie Fleet",
    detail: "Dropside & canopy — parcels, pallets and tight urban access",
    img: IMAGES.isuzuBakkie,
    alt: "Isuzu bakkie from the NGCONDE fleet",
  },
  {
    idx: "02",
    caption: "Isuzu Truck Linehaul",
    detail: "Box-body capacity for scheduled regional distribution runs",
    img: IMAGES.isuzuTruck,
    alt: "Isuzu truck used for NGCONDE linehaul contracts",
  },
];

export const FleetStrip = () => (
  <section className="bg-[#0D1424] pb-20 md:pb-28" data-testid="fleet-section">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <Reveal>
        <p className="flex items-center gap-3 font-mono text-xs font-semibold uppercase tracking-[0.25em] text-[#FF6B00]">
          <span className="inline-block h-px w-8 bg-[#FF6B00]" aria-hidden="true" />
          Our Fleet
        </p>
      </Reveal>
      <Reveal delay={0.08}>
        <h2 className="mt-4 max-w-2xl font-display text-3xl font-black uppercase leading-[1.02] tracking-tight text-white sm:text-4xl">
          Isuzu steel, ready to contract.
        </h2>
      </Reveal>

      <div className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-5">
        {FLEET.map((v, i) => (
          <Reveal key={v.idx} delay={i * 0.1}>
            <figure
              data-testid={`fleet-card-${v.idx}`}
              className="group relative h-[300px] overflow-hidden rounded-2xl border border-white/10 transition-colors duration-300 hover:border-[#FF6B00]/60 md:h-[400px]"
            >
              <img
                src={v.img}
                alt={v.alt}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
              />
              <div
                className="absolute inset-0 bg-gradient-to-t from-[#080C14] via-[#080C14]/35 to-transparent"
                aria-hidden="true"
              />
              <figcaption className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                <p className="font-mono text-xs font-semibold tracking-[0.3em] text-[#FF6B00]">
                  {v.idx}
                </p>
                <p className="mt-2 font-display text-xl font-black uppercase tracking-tight text-white md:text-2xl">
                  {v.caption}
                </p>
                <p className="mt-1 text-sm text-slate-300">{v.detail}</p>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
